import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";

// Fallback logos
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

import axios from "../utills/api";

// Import Components
import VerticalLayout from "./VerticalLayouts";
import { Container } from "reactstrap";

const Sidebar = ({ layoutType }) => {

  // Property logo state
  const [hotelLogo, setHotelLogo] = useState("");

  useEffect(() => {

    const fetchPropertyProfile = async () => {

      try {

        const response = await axios.get(
          "/property-profile"
        );

        console.log(
          "🏨 PROPERTY PROFILE:",
          response.data
        );

        const logoPath =
          response.data?.profile?.hotelLogo ||
          response.data?.client?.hotelLogo ||
          "";

        if (!logoPath) {
          return;
        }

        // If API already sends complete URL
        if (
          logoPath.startsWith("http://") ||
          logoPath.startsWith("https://")
        ) {

          setHotelLogo(logoPath);
          return;
        }

        /*
          DEVELOPMENT:
          api.defaults.baseURL
          = http://localhost:5001/api
  
          Remove /api
          → http://localhost:5001
  
          PRODUCTION:
          api.defaults.baseURL
          = /api
  
          Backend is same domain
          → use relative path directly
        */

        const baseURL = axios.defaults.baseURL;

        if (
          baseURL &&
          baseURL.startsWith("http")
        ) {

          const backendOrigin =
            baseURL.replace(/\/api\/?$/, "");

          setHotelLogo(
            `${backendOrigin}${logoPath}`
          );

        } else {

          // Production
          setHotelLogo(logoPath);

        }

      } catch (error) {

        console.error(
          "❌ Failed to fetch property profile:",
          error
        );

      }

    };

    fetchPropertyProfile();

  }, []);

  useEffect(() => {

    const verticalOverlay =
      document.getElementsByClassName(
        "vertical-overlay"
      );

    if (verticalOverlay.length > 0) {

      verticalOverlay[0].addEventListener(
        "click",
        function () {
          document.body.classList.remove(
            "vertical-sidebar-enable"
          );
        }
      );

    }

  }, []);


  const syncICAL = async () => {

    try {

      const payload = {

        tenantId: "TN1779081301554",

        roomTypeId:
          "6a153d5391e142545f943b1b",

        otaName: "Airbnb",

        icalUrl:
          "http://localhost:5000/api/ical/export/TN1779081301554/6a153d5391e142545f943b1b",
      };

      const res = await axios.post(
        "/ical/import",
        payload
      );

      console.log(res.data);

      alert(
        `Imported ${res.data.imported} bookings`
      );

    } catch (err) {

      console.log(err);

      alert("Sync failed");

    }

  };


  const addEventListenerOnSmHoverMenu = () => {

    if (
      document.documentElement.getAttribute(
        "data-sidebar-size"
      ) === "sm-hover"
    ) {

      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );

    } else if (

      document.documentElement.getAttribute(
        "data-sidebar-size"
      ) === "sm-hover-active"

    ) {

      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover"
      );

    } else {

      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover"
      );

    }

  };


  return (

    <React.Fragment>

      <div className="app-menu navbar-menu">

        <div className="navbar-brand-box">

          {/* DARK LOGO */}

          <Link to="/" className="logo logo-dark">

            <span className="logo-sm">

              <img
                src={hotelLogo || logoSm}
                alt="Hotel Logo"
                height="80"
                style={{
                  objectFit: "contain"
                }}
              />

            </span>

            <span className="logo-lg">

              <img
                src={hotelLogo || logoDark}
                alt="Hotel Logo"
                height="80"
                style={{
                  maxWidth: "180px",
                  objectFit: "contain"
                }}
              />

            </span>

          </Link>


          <Link to="/" className="logo logo-light">

            <span className="logo-sm">

              <img
                src={hotelLogo || logoSm}
                alt="Hotel Logo"
                height="80"
                style={{
                  objectFit: "contain"
                }}
              />

            </span>

            <span className="logo-lg">

              <img
                src={hotelLogo || logoLight}
                alt="Hotel Logo"
                height="80"
                style={{
                  maxWidth: "180px",
                  objectFit: "contain"
                }}
              />

            </span>

          </Link>


          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >

            <i className="ri-record-circle-line"></i>

          </button>

        </div>


        <div className="px-3 py-2"></div>


        {layoutType === "horizontal" ? (

          <div id="scrollbar">

            <Container fluid>

              <div id="two-column-menu"></div>

              <ul
                className="navbar-nav"
                id="navbar-nav"
              >

                <HorizontalLayout />

              </ul>

            </Container>

          </div>

        ) : layoutType === "twocolumn" ? (

          <React.Fragment>

            <TwoColumnLayout
              layoutType={layoutType}
            />

            <div className="sidebar-background"></div>

          </React.Fragment>

        ) : (

          <React.Fragment>

            <SimpleBar
              id="scrollbar"
              className="h-100"
            >

              <Container fluid>

                <div id="two-column-menu"></div>

                <ul
                  className="navbar-nav"
                  id="navbar-nav"
                >

                  <VerticalLayout
                    layoutType={layoutType}
                  />

                </ul>

              </Container>

            </SimpleBar>

            <div className="sidebar-background"></div>

          </React.Fragment>

        )}

      </div>

      <div className="vertical-overlay"></div>

    </React.Fragment>

  );

};

export default Sidebar;